<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="FeeForm">
                            <div class="col-lg-12 col-md-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class=" d-flex align-items-center pl-3">
                                                    <img alt="Logo" src="../../assets/images/receipt.png"
                                                        class="mh-45px pb-2">
                                                    <div class="ml-2">
                                                        <h3 class="main-content-label mb-1"><b>
                                                                Exam Fees
                                                            </b></h3>
                                                        <p class="text-muted card-sub-title mb-0">
                                                            List Of Exam Fee Templates
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-1">

                                            </div>
                                            <div class="col-md-3 form-group">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Session</mat-label>
                                                    <mat-select #select232 placeholder="Session" class="colorblack">
                                                        <mat-select-filter *ngIf="select232.focused" formControlName="SessionId"
                                                        [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                        [array]="sessionList" 
                                                        (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of SessionFilterList"
                                                        [value]="item.SnNo" (click)="onSelect(item.SnNo)">
                                                        {{item.SnName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row clearfix mt-2">
                                            <div *ngIf="Table" class="table-responsive table-container tab mt-1">
                                                <table class="table table-bordered  text-left">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th class="f600">
                                                                Student Name
                                                            </th>
                                                            <th class="f600">
                                                                Course Name
                                                            </th>
                                                            <th class="f600">
                                                                College Name
                                                            </th>
                                                            
                                                            <th *ngIf="payBtnShow" width="10%" class="f600 text-center">
                                                                Action</th>
                                                            <th width="10%" *ngIf="PayStatus" class="f600 text-center">
                                                                Receipt</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="feeApplyArray">
                                                        <tr *ngFor="let fee of getfeeApplyArrayControls(); let i = index; let last = last; let item of FeeTable "
                                                            [formGroupName]="i">
                                                            <td>
                                                                <input class="form-controls input-sm"
                                                                    formControlName="StudentName" readonly>
                                                            </td>
                                                            <td>
                                                                {{  courseName}}
                                                               </td>
                                                            <td>
                                                                  {{collegeName}}
                                                            </td>
                                                            
                                                            <td *ngIf="payBtnShow" class="text-center">
                                                                <button type="button" *ngIf="PayBtn"
                                                                    [disabled]="ShowMsg || ShowMsg3"
                                                                    class="btn sz btn-primary btn-icon-text floatright mt-1 fr"
                                                                    (click)="openFeeProcessPopUp(item)">
                                                                    <span
                                                                        style="display: contents; align-items: center;">
                                                                        <img width="20vh"
                                                                            src="../../assets/images/pay-per-click.gif"
                                                                            style="margin-right: 5px;">
                                                                        Pay
                                                                    </span>
                                                                </button>
                                                                <h3 class="main-content-label mb-1" *ngIf="PayStatus">
                                                                    <b
                                                                    [class.disabled]="updateBtn" (click)="!updateBtn ? openFeeProcessPopUp(item) : null">{{FeePaid}}</b>
                                                                </h3>
                                                                <h3  class="main-content-label mb-1" *ngIf="PayLater">
                                                                    <b [class.disabled]="updateBtn" (click)="!updateBtn ? openFeeProcessPopUp(item) : null">{{FeePaid}}</b>
                                                                </h3>
                                                            </td>
                                                            <td *ngIf="PayStatus">
                                                                <div>
                                                                    <h3  [class.disabled]="updateBtn" (click)="!updateBtn ? addnewrecord(item) : null"
                                                                     class="main-content-label mb-1 ">
                                                                      <!--   (click)="addnewrecord(fee)" -->
                                                                        <b>Payment Status</b>
                                                                    </h3>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div *ngIf="ShowMsg">
                                                <p><b class="red">Note : {{Message}}</b></p>
                                            </div>
                                            <div *ngIf="ShowMsg2">
                                                <p><b class="red">Note : {{Message2}}</b></p>
                                            </div>
                                            <div *ngIf="ShowMsg3">
                                                <p><b class="red">Note : {{Message3}}</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>